export default "../bundles/ed7d47b63b7d18762a2020dc7e84b1e5.gif";